<template>
<div class="chapter">
<div class="inner_page">
<div id="dedication">
<p class="othertext"><a id="page_4"></a><em>EM AND SM: For Mom and Dad and for Daniel and Julian</em></p>
<p class="othertext"><em>SF: For Sophie Bea</em></p>
<p class="center">*</p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 004dedication.vue?64ee4910